<template>
  <div class="w-full">
    <div class="w-full relative">
      <img
        src="@/assets/images/joinus-bg.png"
        alt="bg"
        class="w-full cvr-img-ht"
      />
      <p class="text-black covertext absolute">Dance & art of the touch</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
